import React, { useRef, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom";
import { SearchProvider, SearchContext } from "./SearchContext";
import ProductPage from "./pages/Productpage";
import Services from "./pages/Services";
import Nosotros from "./pages/Nosotros";
import Contacto from "./pages/Contacto";
import Avisso from "./pages/Aviso";
import logo from "./imagenes/Logo/negativo_TLC.png";
import { turboHe451vE, kit351, crtHt60, flHe561V, geoCHe551, propHe561V, Vgthe561 } from "./imagenes";
import reel from "./imagenes/Modelos/reel.jpg";


// Header con buscador global
function Header() {
  const { search, setSearch } = React.useContext(SearchContext);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  function handleSearch(e) {
    setSearch(e.target.value);
  }

  function handleSubmit(e) {
    e.preventDefault();
    navigate("/productos");
    setMenuOpen(false);
  }

  return (
    <header className="flex items-center justify-between border-b border-solid border-b-[#283339] px-4 py-3 sm:px-10 relative z-50 bg-[#1c2327]">
      <div className="flex items-center gap-4">
        <img src={logo} alt="TLC.MX Logo" className="h-8 w-auto" />
      </div>
      {/* Botón hamburguesa */}
      <button
        className="sm:hidden text-white text-3xl"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Abrir menú"
      >
        <span className="material-symbols-outlined">{menuOpen ? "close" : "menu"}</span>
      </button>
      {/* Menú principal */}
      <nav
        className={`flex-col sm:flex-row sm:flex items-center gap-6 absolute sm:static top-full left-0 w-full sm:w-auto bg-[#1c2327] sm:bg-transparent transition-all duration-300 ${
          menuOpen ? "flex" : "hidden sm:flex"
        }`}
      >
        <Link className="text-white text-sm font-medium py-3 sm:py-0 px-6 sm:px-0" to="/" onClick={() => setMenuOpen(false)}>Inicio</Link>
        <Link className="text-white text-sm font-medium py-3 sm:py-0 px-6 sm:px-0" to="/productos" onClick={() => setMenuOpen(false)}>Productos</Link>
        <Link className="text-white text-sm font-medium py-3 sm:py-0 px-6 sm:px-0" to="/servicios" onClick={() => setMenuOpen(false)}>Servicios</Link>
        <Link className="text-white text-sm font-medium py-3 sm:py-0 px-6 sm:px-0" to="/nosotros" onClick={() => setMenuOpen(false)}>Acerca de Nosotros</Link>
        <Link className="text-white text-sm font-medium py-3 sm:py-0 px-6 sm:px-0" to="/contacto" onClick={() => setMenuOpen(false)}>Contacto</Link>
        {/* Buscador solo en desktop */}
        <form className="hidden sm:flex items-center gap-2" onSubmit={handleSubmit}>
          <input
            value={search}
            onChange={handleSearch}
            placeholder="Buscar productos..."
            className="form-input rounded-lg px-2 py-1 bg-[#283339] text-white text-base"
          />
          <button type="submit" className="bg-primary text-white px-3 py-1 rounded-lg font-bold">Buscar</button>
        </form>
      </nav>
    </header>
  );
}

// Componente LandingPage con todo el contenido de la landing
function LandingPage() {
  const carouselRef = useRef(null);

  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const buildWhatsAppLink = (name) =>
    `https://wa.me/527531169174?text=${encodeURIComponent(
      "Hola, quiero información sobre " + name
    )}`;

  return (
    <>
      {/* Hero */}
      <div className="@container w-full">
        <div className="p-0">
          <div
            className="flex min-h-[480px] flex-col gap-6 bg-cover bg-center bg-no-repeat items-start justify-center px-4 pb-10 @[480px]:px-10 @[480px]:gap-8"
            data-alt="high quality image of a turbocharger"
            style={{
              backgroundImage:`linear-gradient(rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.4) 100%), url(${reel})`,
            }}
          >
            <div className="flex flex-col gap-2 text-left max-w-4xl mx-auto w-full px-4 text-center">
              <h1 className="text-white text-4xl font-black leading-tight tracking-[-0.033em] @[480px]:text-5xl @[480px]:font-black @[480px]:leading-tight @[480px]:tracking-[-0.033em]"> Potencia y Rendimiento Garantizado </h1>
              <h2 className="text-white text-sm font-normal leading-normal @[480px]:text-base @[480px]:font-normal @[480px]:leading-normal"> Especialistas en venta y reparación de turbos para todas las marcas. </h2>
            </div>
          </div>
        </div>
      </div>
      {/* Ofertas Destacadas */}
      <div className="w-full px-10">
        <h2 className="text-white text-[22px] font-bold leading-tight tracking-[-0.015em] px-4 pb-3 pt-5">Ofertas Destacadas</h2>
        <div className="relative">
          {/* Flecha Izquierda */}
          <button
            onClick={scrollLeft}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-[#1c2327] bg-opacity-80 hover:bg-primary text-white rounded-full p-2 shadow-lg hidden md:block"
            aria-label="Anterior"
            style={{ left: "-24px" }}
          >
            <span className="material-symbols-outlined">chevron_left</span>
          </button>
          {/* Carrusel */}
          <div
            ref={carouselRef}
            className="flex overflow-x-auto scroll-smooth gap-8 pb-4 px-2 hide-scrollbar"
            style={{ scrollBehavior: "smooth" }}
          >
            {/* Tarjeta 1 */}
            <div className="relative flex flex-col gap-4 rounded-lg bg-[#1c2327] shadow min-w-[220px] max-w-[240px] border-2 border-transparent hover:border-primary transition-all duration-300">
              <div className="w-full aspect-square flex items-center justify-center bg-[#222] rounded-t-lg overflow-hidden">
                <img src={turboHe451vE} alt="Turbo HE451VE" className="object-cover w-full h-full" />
              </div>
              <div className="flex flex-col flex-1 justify-between p-4 pt-0 gap-4">
                <div>
                  <p className="text-white text-base font-medium leading-normal">Turbo HE451VE</p>
                </div>
                <a
                  href={buildWhatsAppLink("Turbo HE451VE")}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Comprar Turbo HE451VE por WhatsApp"
                  className="flex min-w-[84px] max-w-[180px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-10 px-4 bg-primary text-white text-sm font-bold leading-normal tracking-[0.015em] transform hover:scale-105 transition-transform duration-200"
                >
                  <span className="truncate">¡Comprar Ahora!</span>
                </a>
              </div>
            </div>
            {/* Tarjeta 2 */}
            <div className="relative flex flex-col gap-4 rounded-lg bg-[#1c2327] shadow min-w-[220px] max-w-[240px] border-2 border-transparent hover:border-primary transition-all duration-300">
              <div className="w-full aspect-square flex items-center justify-center bg-[#222] rounded-t-lg overflow-hidden">
                <img src={kit351} alt="Kit de servicio HE351" className="object-cover w-full h-full" />
              </div>
              <div className="flex flex-col flex-1 justify-between p-4 pt-0 gap-4">
                <div>
                  <p className="text-white text-base font-medium leading-normal">Kit de servicio HE351</p>
                </div>
                <a
                  href={buildWhatsAppLink("Kit de servicio HE351")}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Comprar Kit de servicio HE351 por WhatsApp"
                  className="flex min-w-[84px] max-w-[180px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-10 px-4 bg-primary text-white text-sm font-bold leading-normal tracking-[0.015em] transform hover:scale-105 transition-transform duration-200"
                >
                  <span className="truncate">¡Comprar Ahora!</span>
                </a>
              </div>
            </div>
            {/* Tarjeta 3 */}
            <div className="relative flex flex-col gap-4 rounded-lg bg-[#1c2327] shadow min-w-[220px] max-w-[240px] border-2 border-transparent hover:border-primary transition-all duration-300">
              <div className="w-full aspect-square flex items-center justify-center bg-[#222] rounded-t-lg overflow-hidden">
                <img src={crtHt60} alt="Cartucho HT60" className="object-cover w-full h-full" />
              </div>
              <div className="flex flex-col flex-1 justify-between p-4 pt-0 gap-4">
                <div>
                  <p className="text-white text-base font-medium leading-normal">Cartucho HT60</p>
                </div>
                <a
                  href={buildWhatsAppLink("Cartucho HT60")}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Comprar Cartucho HT60 por WhatsApp"
                  className="flex min-w-[84px] max-w-[180px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-10 px-4 bg-primary text-white text-sm font-bold leading-normal tracking-[0.015em] transform hover:scale-105 transition-transform duration-200"
                >
                  <span className="truncate">¡Comprar Ahora!</span>
                </a>
              </div>
            </div>
            {/* Tarjeta 4 */}
            <div className="relative flex flex-col gap-4 rounded-lg bg-[#1c2327] shadow min-w-[220px] max-w-[240px] border-2 border-transparent hover:border-primary transition-all duration-300">
              <div className="w-full aspect-square flex items-center justify-center bg-[#222] rounded-t-lg overflow-hidden">
                <img src={flHe561V} alt="Flecha HE561V" className="object-cover w-full h-full" />
              </div>
              <div className="flex flex-col flex-1 justify-between p-4 pt-0 gap-4">
                <div>
                  <p className="text-white text-base font-medium leading-normal">Flecha HE561V</p>
                </div>
                <a
                  href={buildWhatsAppLink("Flecha HE561V")}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Comprar Flecha HE561V por WhatsApp"
                  className="flex min-w-[84px] max-w-[180px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-10 px-4 bg-primary text-white text-sm font-bold leading-normal tracking-[0.015em] transform hover:scale-105 transition-transform duration-200"
                >
                  <span className="truncate">¡Comprar Ahora!</span>
                </a>
              </div>
            </div>
            {/* Tarjeta 5 */}
            <div className="relative flex flex-col gap-4 rounded-lg bg-[#1c2327] shadow min-w-[220px] max-w-[240px] border-2 border-transparent hover:border-primary transition-all duration-300">
              <div className="w-full aspect-square flex items-center justify-center bg-[#222] rounded-t-lg overflow-hidden">
                <img src={geoCHe551} alt="Geometria Completa" className="object-cover w-full h-full" />
              </div>
              <div className="flex flex-col flex-1 justify-between p-4 pt-0 gap-4">
                <div>
                  <p className="text-white text-base font-medium leading-normal">Geometria Completa</p>
                </div>
                <a
                  href={buildWhatsAppLink("Geometria Completa")}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Comprar Geometria Completa por WhatsApp"
                  className="flex min-w-[84px] max-w-[180px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-10 px-4 bg-primary text-white text-sm font-bold leading-normal tracking-[0.015em] transform hover:scale-105 transition-transform duration-200"
                >
                  <span className="truncate">¡Comprar Ahora!</span>
                </a>
              </div>
            </div>
            {/* Tarjeta 6 */}
            <div className="relative flex flex-col gap-4 rounded-lg bg-[#1c2327] shadow min-w-[220px] max-w-[240px] border-2 border-transparent hover:border-primary transition-all duration-300">
              <div className="w-full aspect-square flex items-center justify-center bg-[#222] rounded-t-lg overflow-hidden">
                <img src={Vgthe561} alt="Modulo vgt he561" className="object-cover w-full h-full" />
              </div>
              <div className="flex flex-col flex-1 justify-between p-4 pt-0 gap-4">
                <div>
                  <p className="text-white text-base font-medium leading-normal">Modulo VGT HE561</p>
                </div>
                <a
                  href={buildWhatsAppLink("Modulo VGT HE561")}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Comprar Modulo VGT HE561 por WhatsApp"
                  className="flex min-w-[84px] max-w-[180px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-10 px-4 bg-primary text-white text-sm font-bold leading-normal tracking-[0.015em] transform hover:scale-105 transition-transform duration-200"
                >
                  <span className="truncate">¡Comprar Ahora!</span>
                </a>
              </div>
            </div>
            
          </div>
          {/* Flecha Derecha */}
          <button
            onClick={scrollRight}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-[#1c2327] bg-opacity-80 hover:bg-primary text-white rounded-full p-2 shadow-lg hidden md:block"
            aria-label="Siguiente"
            style={{ right: "-24px" }}
          >
            <span className="material-symbols-outlined">chevron_right</span>
          </button>
        </div>
        {/* Marcas 
        <h2 className="text-white text-[22px] font-bold leading-tight tracking-[-0.015em] px-14 pb-3 pt-5">Marcas que Manejamos</h2>
        <div className="flex overflow-y-auto [-ms-scrollbar-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden w-full">
          <div className="flex items-center justify-center p-4 gap-8 w-full">
            <img className="h-10 opacity-70 hover:opacity-100 transition-opacity" alt="Brand 1 logo" src="https://lh3.googleusercontent.com/aida-public/AB6AXuB0hXohcbaT1zjbgu32C6jrIXW8YgVWQ4qu_Qq_E45JVzSRUEM8rMh6lZk8cv-GzAkJwsWNezWea_cYd408HfSJxCvXSwL5m0GTHIco_CXLjA40A8K2asTBt5vH7Xz1RzmaOs4o-M36o269HDiisqtfUlddVl8wEVGBtHK1GuaGM3ey-SswEtAij5jzAJ48kXwqely5UPo9Kx4qWU_IDMNsgotClU9qkUUHqRWe7Ef4_AeKwG3dCaw1LxRCflN1USw_2SaxJ1qfT97x" />
            <img className="h-10 opacity-70 hover:opacity-100 transition-opacity" alt="Brand 2 logo" src="https://lh3.googleusercontent.com/aida-public/AB6AXuBKGhdv4EQFc8RP9oNiDk_v28J7VXsIKVBrxH7p_n7iOpX-2U4LDjaIgQfa_pez-_IejxW0l2Oq7ieF-QE0zQCxuHx6NK1hBXPRafBi0vN9g-V3YIwEw0al1juJ9tKS3GAkplPTGNBWoIsFNmUgl49owcW-H00gYmTM_adit8V8AnWKtxb26vT1ddAQlSOC02d40HjKKyayHx5G_MMD-NDlitBCfyLNWLFQvi2vxNRpcgiGOaq3fcaD3BaXI496YcXipz3cWd6uj-fd" />
            <img className="h-10 opacity-70 hover:opacity-100 transition-opacity" alt="Brand 3 logo" src="https://lh3.googleusercontent.com/aida-public/AB6AXuBsU8Ge7RX1eaWkCPDuCdUyI9pGPqTFHd6dhBsK9MzAFVJUW-0c5dOIa_9u7s496DOTSzV_wnkrhEeCJOoz6o3FFCs42MXuf4RwGy6C2qGPf6_WSkGo08esIJifVEWKkF4etax2N6F_pG6irHLZVG0VBuq9ggd6_tsvzG0HLzZSCpA4La6629PL7weP_DHkErhDz8DaZwLNU5EwLFtRO2z5LyJs9fyeyse_7dnKGqbrKJLAPXAViRK5HUvbukWzXpbvel51MbB96G7z" />
            <img className="h-10 opacity-70 hover:opacity-100 transition-opacity" alt="Brand 4 logo" src="https://lh3.googleusercontent.com/aida-public/AB6AXuCegJIK7BHZzwuWojoGtIxnkUPLdsKEPKKh1csGcrxevHMabZM0w6ZbZKPU5IA_baoI7TO7K2fLf-fDHLiAUWywreYWFYci2UEACVJ1PNy3_jblpzN_Gu-0-BLDVHnm_Fy2LRvwgGtoBuvu1Rww-kfI9XB0QI2L5_cBYT-AhQqbaOyxyBCmO_WvLyjZ4pdjch9n_hVkXuz55feMI4uYecv_rDixIRMKXka6NPQRGQreU9c0ZxDiuyjh1ip71vOu6Zsm23vaFekix66j" />
            <img className="h-10 opacity-70 hover:opacity-100 transition-opacity" alt="Brand 5 logo" src="https://lh3.googleusercontent.com/aida-public/AB6AXuCWeZZgOJ6vDcwmYZlycjfc9jBiW8hxBjHFzPyF4fzu-lDWyNuA9HtsHYzeNm71P729-J2khhpYVzCV6E0QfnZgeFdEd5K9oV09gWKzRxCYRKoimEmcaR6tHr9UsUM_CLDSStT5z4l87vcmRJZSxkvdJBO90qr5rdFMg9wI78SDD-i9e-FqBVrFy3iq9pXTWNLhb321iA2IugNYtOsb2rNCFZ_8CW2Op--AgwY2t2Jyg9O-RR7GLYK3od5dx7pAb-_mjCJBsomKfQ3_" />
            <img className="h-10 opacity-70 hover:opacity-100 transition-opacity" alt="Brand 6 logo" src="https://lh3.googleusercontent.com/aida-public/AB6AXuAZuOT_-e_hTUbf2oyCmcgdgI5zXeusARiyyeTnezIRGzXNXan0ZoFJpzxPEweoRtAwfJwp_xmcm1p7p_IwnPVm0D_j_UiVJyj3b9UaaDsLk4uRbo-kCJyGpt4v3T4oasysR9aTtXD2_hEug0Z5i6l5kX66QB9tKh--Bq5uLOwPeHG5wrb6oe6ZbtlHDI3AlbRbFYQCKUNrSnEre-qrYDWe2ZGXIv2fk_eUxTi1tTWOYHQ8jtUouiNqRXzlBtxhXTvC02Der8IGNGXJ" />
          </div>
        </div>*/}
      </div>
    </>
  );
}

export default function App() {
  return (
    <SearchProvider>
      <Router>
        <div className="relative flex h-auto min-h-screen w-full flex-col bg-[#111618] dark group/design-root overflow-x-hidden">
          <div className="flex h-full grow flex-col">
            <div className="flex flex-1 justify-center py-0">
              <div className="flex w-full flex-col flex-1">
                <Header />
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/productos" element={<ProductPage />} />
                  <Route path="/servicios" element={<Services />} />
                  <Route path="/nosotros" element={<Nosotros />} />
                  <Route path="/contacto" element={<Contacto />} />
                  <Route path="/aviso" element={<Avisso />} />
                </Routes>
                {/* Footer */}
      <footer className="w-full mt-10 border-t border-solid border-t-[#283339] text-white py-8 px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="font-bold text-lg mb-4">Navegación</h3>
            <ul className="space-y-2 text-sm text-[#9db0b9]">
              <li><Link className="hover:text-primary" to="/">Inicio</Link></li>
              <li><Link className="hover:text-primary" to="productos">Productos</Link></li>
              <li><a className="hover:text-primary" href="servicios">Servicios</a></li>
              <li><a className="hover:text-primary" href="nosotros">Acerca de Nosotros</a></li>
              <li><a className="hover:text-primary" href="contacto">Contacto</a></li>
              <li><a className="hover:text-primary" href="aviso">Aviso de privacidad</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold text-lg mb-4">Contacto</h3>
            <ul className="space-y-2 text-sm text-[#9db0b9]">
              <li>Dirección: Av. Las Palmas 24, Del Carmen, 60952</li> 
                <li>Cdad. Lázaro Cárdenas, Mich.</li>
              <li>Telefono: +52 75 311 69174</li>
              <li>Email: ventas@tlc.mx</li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold text-lg mb-4">Síguenos</h3>
            <div className="flex space-x-4">
              <a className="text-[#9db0b9] hover:text-primary" href="#"><svg aria-hidden="true" className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path clipRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" fillRule="evenodd"></path></svg></a>
              <a className="text-[#9db0b9] hover:text-primary" href="#"><svg aria-hidden="true" className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.71v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"></path></svg></a>
              <a className="text-[#9db0b9] hover:text-primary" href="#"><svg aria-hidden="true" className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path clipRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.024.06 1.378.06 3.808s-.012 2.784-.06 3.808c-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.024.048-1.378.06-3.808.06s-2.784-.013-3.808-.06c-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.048-1.024-.06-1.378-.06-3.808s.012-2.784.06-3.808c.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 016.345 2.525c.636-.247 1.363-.416 2.427-.465C9.792 2.013 10.146 2 12.315 2zm-1.161 14.823a4.873 4.873 0 119.746 0 4.873 4.873 0 01-9.746 0zm6.13-7.575a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" fillRule="evenodd"></path></svg></a>
            </div>
          </div>
        </div>
        <div className="mt-8 text-center text-sm text-[#9db0b9] border-t border-solid border-t-[#283339] pt-6"> © 2025 TLC.MX. Todos los derechos reservados. </div>
      </footer>
              </div>
            </div>
          </div>
        </div>
      </Router>
      {/* Botón flotante de WhatsApp */}
      <a
        href="https://wa.me/527531169174"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg flex items-center justify-center w-14 h-14"
        aria-label="WhatsApp"
      >
        <svg viewBox="0 0 32 32" width="32" height="32" fill="currentColor">
          <path d="M16 3C9.373 3 4 8.373 4 15c0 2.385.697 4.607 2.018 6.563L4 29l7.625-2.008A12.96 12.96 0 0016 27c6.627 0 12-5.373 12-12S22.627 3 16 3zm0 22c-1.98 0-3.91-.516-5.594-1.494l-.401-.232-4.531 1.193 1.211-4.418-.26-.426C5.516 18.91 5 16.98 5 15c0-6.065 4.935-11 11-11s11 4.935 11 11-4.935 11-11 11zm5.255-7.255c-.292-.146-1.724-.85-1.99-.947-.267-.098-.461-.146-.655.146-.195.292-.75.947-.92 1.143-.17.195-.34.219-.632.073-.292-.146-1.232-.454-2.35-1.447-.868-.773-1.454-1.726-1.626-2.018-.17-.292-.018-.449.128-.595.131-.13.292-.34.438-.511.146-.17.195-.292.292-.487.097-.195.049-.365-.024-.511-.073-.146-.655-1.584-.897-2.168-.237-.57-.478-.493-.655-.503-.17-.009-.365-.011-.56-.011-.195 0-.511.073-.78.365-.267.292-1.02.997-1.02 2.429 0 1.432 1.044 2.815 1.19 3.009.146.195 2.055 3.142 5.006 4.282.701.302 1.247.482 1.673.616.703.224 1.343.192 1.848.116.564-.084 1.724-.704 1.969-1.382.244-.678.244-1.259.171-1.382-.073-.122-.267-.195-.56-.341z"/>
        </svg>
      </a>
    </SearchProvider>
  );
}
